<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
        <defs>
            <path
                d="M12 7v1.79c0 .45-.54.67-.85.35L8.36 6.35c-.2-.2-.2-.51 0-.71l2.79-2.79a.5.5 0 0 1 .85.36V5c4.42 0 8 3.58 8 8 0 1.04-.2 2.04-.57 2.95-.27.67-1.13.85-1.64.34-.27-.27-.38-.68-.23-1.04.29-.69.44-1.46.44-2.25 0-3.31-2.69-6-6-6zm-6 4h7a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2zm0 2v5h7v-5H6z"
                id="SolidRotateClockwise_solid-rotate-clockwise"></path>
        </defs>
        <use transform="matrix(-1 0 0 1 24 0)" xlink:href="#SolidRotateClockwise_solid-rotate-clockwise"
             fill-rule="evenodd"></use>
    </svg>
</template>
